import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: null,
  userDetails: {},
  agentDetails: {},
  walletAmount: "",
  walletLoading: false,
  profileImage: "",
  userName: "",
  userBetDetails: {
    maxBettingLimit: null,
    canBet: false
  },
  referDetails: {
    referAmount: null,
    referAmountEarned: null
  },
  SbPermission: undefined,
  agentSbPermission: undefined,
  betLimitLoading: false,
  betLimit: []
};

const myProfileSlice = createSlice({
  name: "myProfile",
  initialState,
  reducers: {
    getUserProfileDetailsStart: (state, action) => {
      if (action.payload?.walletLoading) {
        state.walletLoading = true;
      }
      state.loading = true;
    },
    getUserProfileDetailsSuccess: (state, action) => {
      state.loading = false;
      state.userDetails = action.payload;
      if (action.payload?.profileImage) {
        state.profileImage = action.payload.profileImage;
      }
      if (action.payload?.AdminUser) {
        state.agentDetails = action.payload?.AdminUser;
      }
      if (action.payload?.userName) {
        state.userName = action.payload?.userName;
      }
      if (action.payload?.maxBettingLimit) {
        state.userBetDetails = {
          ...state.userBetDetails,
          maxBettingLimit: action.payload?.maxBettingLimit
        };
      }
      if (action.payload?.canBet) {
        state.userBetDetails = {
          ...state.userBetDetails,
          canBet: action.payload?.canBet
        };
      }
      if (action.payload?.referBonus) {
        state.referDetails.referAmount = action.payload?.referBonus;
      }
      if (action.payload?.earningsFromRefer) {
        state.referDetails.referAmountEarned =
          action.payload?.earningsFromRefer;
      }
      state.SbPermission = action?.payload?.SbPermission || null;
      state.agentSbPermission = action?.payload?.agentSbPermission || null;
    },
    getUserProfileDetailsFailure: (state, action) => {
      if (action.payload?.walletLoading) {
        state.walletLoading = false;
      }
      state.loading = false;
      state.error = action.payload;
      state.walletLoading = false;
    },
    updateUserProfileStart: (state, action) => {
      state.loading = true;
    },
    updateUserProfileSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.userDetails = action.payload;
    },
    updateUserProfileFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    getWalletBalanceSuccess: (state, action) => {
      state.walletLoading = false;
      state.walletAmount = action.payload;
    },
    startPoll: () => {},
    resetMyProfileState: () => ({
      ...initialState
    }),
    getBetLimitStart: (state) => {
      state.betLimitLoading = true;
    },
    getBetLimitSuccess: (state, action) => {
      state.betLimitLoading = false;
      state.betLimit = [action.payload];
    },
    getBetLimitFailure: (state) => {
      state.betLimitLoading = false;
    }
  }
});

export const {
  getUserProfileDetailsStart,
  getUserProfileDetailsSuccess,
  getUserProfileDetailsFailure,
  updateUserProfileStart,
  updateUserProfileSuccess,
  updateUserProfileFailure,
  getWalletBalanceSuccess,
  resetMyProfileState,
  startPoll,
  getBetLimitStart,
  getBetLimitSuccess,
  getBetLimitFailure
} = myProfileSlice.actions;

export default myProfileSlice.reducer;
